import React, { useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";

import "./../Dashboard/Navbarlogedin.css";
// import Bookmark from "../Dashboard/popups/Bookmark";

const NavbarInterviewer = () => {
  let navigate = useNavigate();
  const location = useLocation();

  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Profile Dropdown
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //-----

  const openable = useRef();

  const [active, setActive] = useState("/searching");

  const pathname = window.location.pathname.toLowerCase();
  const navItem = document.querySelectorAll(".nav-item a");
  const logging=()=>{
    localStorage.removeItem("isAuthenticated");
  }
  return (
    <>
      {/* <Bookmark /> */}
      <div className="navbarlogedin flex">
        <div className="logo">
          <Link to="/" style={{ textDecoration: "none" }}>
            <h1 className="text-2xl font-medium">interwiu.com</h1>
          </Link>
        </div>
        {location.pathname === "/profile-form" ? (
          <h1
            className="text-4xl font-medium text-center"
            style={{ marginRight: "450px" }}
          >
            Create an Account as a Student
          </h1>
        ) : (
          <>
            <ul className="nav-list flex">
              <li>
                <NavLink
                  end
                  className="nav-item hover-underline-animation"
                  activeClassName="active"
                  to="/interviewer/request"
                >
                  <div>Received Requests</div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  end
                  className="nav-item hover-underline-animation"
                  activeClassName="active"
                  to="/interviewer/accepted"
                >
                  <div className="flex">
                    Accepted Requests <div className="notify"></div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  end
                  className="nav-item hover-underline-animation"
                  activeClassName="active"
                  to="/interviewer/upcoming"
                >
                  <div>Upcoming Interviews</div>
                </NavLink>
              </li>
              <li>
                <NavLink
                  end
                  className="nav-item hover-underline-animation"
                  activeClassName="active"
                  to="/interviewer/completed"
                >
                  <div className="flex">
                    Completed Interviews <div className="notify"></div>
                  </div>
                </NavLink>
              </li>
            </ul>
            <div className="sidebar flex">
              {/* Notification Bell */}
              {location.pathname === "/profile-form" ? null : (
                <div
                  className="notifier rounded border px-3 py-2 m-1 hover:bg-slate-200"
                  onClick={() => {
                    const dropdown = document.querySelector(
                      ".notification-dropdown"
                    );
                    dropdown.classList.toggle("hide");
                  }}
                >
                  <i className="fa-solid fa-bell text-2xl"></i>
                  <div className="dot">76</div>
                </div>
              )}

              <div className="notification-dropdown hide">
                <h4>Notification</h4>
                <hr />
                <div className="notification-item">
                  <h6>Notification Head</h6>
                  <p>
                    Notification Desc such as Lorem ipsum dolor sit amet
                    consectetur adipisicing elit.
                  </p>
                </div>
                <hr />
                <div className="notification-item">
                  <h6>Notification Head</h6>
                  <p>
                    Notification Desc such as Lorem ipsum dolor sit amet
                    consectetur adipisicing elit.
                  </p>
                </div>
              </div>

              {/* Profile Dropdown */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Tooltip title="My Profile">
                  <Button
                    onClick={handleClick}
                    size="small"
                    sx={{ color: "black" }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <div className="sidebar-profile px-2 rounded border cursor-pointer hover:bg-slate-200 flex">
                      <div className="sidebar-profile-img mx-1 flex">
                        <img src={require("../../images/photo.png")} alt="" />
                      </div>
                      <div
                        className="text-sm mx-1 flex"
                        style={{ flexDirection: "column" }}
                      >
                        <p>Me</p>
                        <i className="fa-solid fa-caret-down"></i>
                      </div>
                    </div>
                  </Button>
                </Tooltip>
              </Box>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1,
                    px: 1,
                    width: 300,
                    borderRadius: 2,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Typography>
                  <div className=" profile-dropdown-head flex">
                    <div>
                      <img
                        src={require("../../images/photo.png")}
                        style={{
                          height: "60px",
                          width: "60px",
                          borderRadius: "50%",
                        }}
                        alt=""
                      />
                    </div>
                    <div>
                      <Typography
                        variant="h5"
                        component="h5"
                        sx={{ fontWeight: "bold" }}
                      >
                        John Doe
                      </Typography>
                      <p>SDE, Google, California</p>
                    </div>
                  </div>
                </Typography>
                <button
                  type="button"
                  className="cust-btn view-profile-btn"
                  onClick={() => {
                    navigate("/interviewer/dashboard");
                  }}
                >
                  View Profile
                </button>
                <Divider />
                <MenuItem
                  className="dropdown-btn"
                  onClick={() => {
                    document.querySelector(".bookmark").style.visibility =
                      "visible";
                  }}
                >
                  <p>
                    <i className="fa-solid fa-bookmark"></i> Bookmarks
                  </p>
                </MenuItem>

                <MenuItem
                  className="dropdown-btn"
                  onClick={() => {
                    navigate("/declined-requests");
                  }}
                >
                  <p>
                    <i className="fa-solid fa-circle-xmark"></i> Declined
                    Requests
                  </p>
                </MenuItem>
                <MenuItem
                  className="dropdown-btn"
                  onClick={() => {
                    navigate("/canceled-interviews");
                  }}
                >
                  <p>
                    <i className="fa-solid fa-ban"></i> Canceled Mock Interviews
                  </p>
                </MenuItem>
                <MenuItem className="dropdown-btn">
                  <p>
                    <i className="fa-solid fa-triangle-exclamation"></i>{" "}
                    Reschedule a Mock Interview
                  </p>
                </MenuItem>
                <MenuItem className="dropdown-btn">
                  <p>
                    <i className="fa-solid fa-triangle-exclamation"></i> Cancel
                    a Mock Interview
                  </p>
                </MenuItem>
                <MenuItem className="dropdown-btn">
                  <p>
                    <i className="fa-solid fa-triangle-exclamation"></i> Report
                    an Issue
                  </p>
                </MenuItem>
                <MenuItem className="dropdown-btn">
                  <p>
                    <i className="fa-solid fa-gear"></i> Account Settings
                  </p>
                </MenuItem>
                <hr />
                <form
                  action={`${process.env.REACT_APP_SERVER_URL}/auth/logout`}
                >
                  <button
                    type="submit"
                    className="cust-btn logout-btn"
                    onClick={logging}
                  >
                    <i className="fa-solid fa-arrow-right-from-bracket"></i> Log
                    Out
                  </button>
                </form>
              </Menu>
              <IconButton
                aria-label="more"
                className="navLoggedInDropdownIcon"
                id="long-button"
                aria-controls={Boolean(anchorEl2) ? "long-menu" : undefined}
                aria-expanded={Boolean(anchorEl2) ? "true" : undefined}
                aria-haspopup="true"
                onClick={(e) => setAnchorEl2(e.currentTarget)}
              >
                <MenuRoundedIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl2}
                open={Boolean(anchorEl2)}
                onClose={() => setAnchorEl2(null)}
              >
                <MenuItem>
                  <NavLink
                    end
                    className="nav-item hover-underline-animation"
                    activeClassName="active"
                    to="/interviewer/request"
                  >
                    <div>Received Requests</div>
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    end
                    className="nav-item hover-underline-animation"
                    activeClassName="active"
                    to="/interviewer/accepted"
                  >
                    <div className="flex">
                      Accepted Requests <div className="notify"></div>
                    </div>
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    end
                    className="nav-item hover-underline-animation"
                    activeClassName="active"
                    to="/interviewer/upcoming"
                  >
                    <div>Upcoming Interviews</div>
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    end
                    className="nav-item hover-underline-animation"
                    activeClassName="active"
                    to="/interviewer/completed"
                  >
                    <div className="flex">
                      Completed Interviews <div className="notify"></div>
                    </div>
                  </NavLink>
                </MenuItem>
              </Menu>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default NavbarInterviewer;
